import React from "react";
import { Link } from "react-router-dom";

/* ── Inline SVG icons (aria-hidden — all context is in the section aria-label) ── */
const ShieldIcon = () => (
  <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
      d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
  </svg>
);
const TrendIcon = () => (
  <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
      d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
  </svg>
);
const UsersIcon = () => (
  <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
      d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);
/* Circular arrow used on the secondary CTA */
const CircleArrowIcon = () => (
  <svg width="20" height="20" fill="none" viewBox="0 0 24 24" aria-hidden="true">
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.6" />
    <path d="M10 8l4 4-4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const NewHero = () => (
  <section className="hero-v2" aria-labelledby="hero-heading">
    {/* Full-bleed bridge visual + navy gradient for copy legibility */}
    <div
      className="hero-v2-bg"
      role="img"
      aria-label="Bridge from your existing systems, powered by AI, to a future-ready enterprise"
    />

    <div className="container hero-v2-inner">
      <div className="hero-v2-copy">
        <span className="hero-v2-tag">The Legacy-to-AI Bridge</span>
        <h1 id="hero-heading">
          You don&rsquo;t have to<br />abandon what works.
        </h1>
        <p className="hero-v2-lead">
          We ingest AI into your existing systems gradually&mdash;
          protecting your investment while making you future-ready.
        </p>
        <ul className="hero-v2-bullets" aria-label="Key delivery capabilities">
          <li><ShieldIcon /><span>Protect your existing investment</span></li>
          <li><TrendIcon /><span>Introduce AI gradually and safely</span></li>
          <li><UsersIcon /><span>Run, modernize and innovate&mdash;simultaneously</span></li>
        </ul>
        <div className="hero-v2-ctas">
          <Link to="/contact-us" className="hero-v2-btn-primary">Talk to Us</Link>
          <Link to="/services/legacy-modernization" className="hero-v2-btn-outline">
            See How It Works
            <CircleArrowIcon />
          </Link>
        </div>
      </div>
    </div>
  </section>
);

export default NewHero;
